import {DataContainer, Feature, FeatureStatus, submitMerge, submitMiniAction} from '@otto-ec/tracking-bct';
import {PictureTextType, TRACKING_PROMO_TYPE, TrackingWidgetTile} from "./types";

export default class GenericTrackingService {

    sendLoadedTracking(featureOrder: number, featureIndex: number, parentTrackingId: string, widgetTiles: TrackingWidgetTile[], masFeatureTrackingLabels: DataContainer, moduleType: PictureTextType) {
        const trackingFeatures = [
            this.createWidgetFeature(featureOrder, featureIndex, parentTrackingId, widgetTiles.length, "loaded", masFeatureTrackingLabels, moduleType),
            ...widgetTiles.map(((widgetTile: TrackingWidgetTile) => {
                return this.createWidgetTileFeature(widgetTile, parentTrackingId, "loaded")
            }))
        ];
        submitMerge({}, trackingFeatures);
    }

    sendClickTrackingEvent(featureOrder: number, featureIndex: number, parentFeatureId: string, widgetTile: TrackingWidgetTile, filledSlots: number, masFeatureTrackingLabels: DataContainer, moduleType: PictureTextType) {
        /*                                                                        */
        /*                                                                                      */
        /*                                                                  */
        const trackingFeatures = [
            this.createWidgetFeature(featureOrder, featureIndex, parentFeatureId, filledSlots, "clicked", masFeatureTrackingLabels, moduleType),
            this.createWidgetTileFeature(widgetTile, parentFeatureId, "clicked")
        ]
        submitMerge({}, trackingFeatures);
    }

    sendScrollTrackingEvent(parentFeatureId: string, featureIds: string[]) {
        const parentFeature = {'featureId': parentFeatureId}
        const tileFeatures = featureIds.map(featureId => {
            return {'featureId': featureId}
        })
        submitMiniAction([parentFeature, ...tileFeatures]);
    }

    private createWidgetFeature(featureOrder: number, featureIndex: number, featureId: string, filledSlots: number, status: FeatureStatus, masFeatureTrackingLabels: DataContainer, moduleType: PictureTextType): Feature {
        const labels = {
            promo_Feature: ["true"],
            promo_FilledSlots: [(filledSlots).toString()],
            promo_FeatureNumber: [(featureIndex + 1).toString()],
            promo_TileType: [moduleType]
        };
        const mergedLabels = {
            ...labels,
            ...masFeatureTrackingLabels
        }
        return {
            id: featureId,
            name: TRACKING_PROMO_TYPE,
            position: featureOrder,
            status: status,
            labels: mergedLabels
        }
    }

    private createWidgetTileFeature(widgetTile: TrackingWidgetTile, parentFeatureId: string, status: FeatureStatus): Feature {
        return {
            id: widgetTile.id,
            parentId: parentFeatureId,
            name: `${TRACKING_PROMO_TYPE}-Tile`,
            position: widgetTile.position,
            status: status,
            labels: widgetTile.labels
        };
    }
}